<template>
  <f7-page>
    <a
      class="fixed right-0 top-0 m-5 rounded-full shadow-lg p-2 leading-3 bg-red-500"
      @click="askForLogout"
    >
      <eva-icon
        name="power-outline"
        fill="#FFFFFF"
        width="32"
        height="32"
      />
    </a>
    <div class="mx-auto w-11/12 sm:w-9/12 sm:min-w-150 max-w-4xl text-center mb-10">
      <img
        class="mx-auto mt-20"
        src="@/assets/no-roles.svg"
        alt="no-roles"
      >
      <div class="text-2xl font-bold max-w-xl mx-auto my-5 text-center">
        <div>
          Parece que el teléfono <span class="text-white bg-purple-500 p-2 rounded-md">{{ usedPhone }}</span> no cuenta con ningun permiso
        </div>
        <div
          class="flex items-center justify-center"
        >
          <div class="align-bottom">
            en
          </div>
          <img
            class="ml-5"
            src="@/assets/Cuidarte-purple.svg"
            alt="cuidarte"
          >
        </div>
      </div>
      <div
        class="text-xl max-w-2xl m-auto text-center mt-5"
      >
        Si haces parte de una entidad que ya usa <b class="text-purple-500">Cuidarte</b>,
        <br>
        solicíta al encargado que te invite con tu número de celular.
      </div>
      <div
        class="mt-10 p-10 bg-bluegray-500 rounded-lg max-w-3xl m-auto text-2xl font-bold"
      >
        <div>
          Si tienes un cargo administrativo y deseas implementar <b class="text-purple-500">Cuidarte</b> en tu organización, presiona en
        </div>
        <a
          class="link external w-56 h-16 p-3 leading-16 cursor-pointer bg-purple-500 text-white text-center text-2xl rounded-full mx-auto my-6 font-bold self"
          href="https://www.cuidarte.co"
        >
          Conocer más
        </a>
      </div>
    </div>
  </f7-page>
</template>
<script>
import { mapState } from 'vuex'
import { firebaseTools } from '../utils/firebase'
export default {
  name: 'NoRoles',
  computed: {
    usedPhone () {
      return this.account.phoneDetails ? this.account.phoneDetails.nationalPhone : 'que usaste'
    },
    ...mapState({
      roles: state => state.auth.roles,
      versionAPK: state => state.settings.versionAPK,
      os: state => state.settings.os,
      account: state => state.auth.account,
    }),
  },
  watch: {
    roles: function () {
      if (Object.keys(this.roles).length > 0) {
        this.$f7.views.main.router.navigate('/', { reloadAll: true })
      }
    },
    account: function () {
      this.$store.commit('auth/checkRoles', this.account)
    },
  },
  mounted () {
    if (this.roles && this.roles.length > 0) {
      if (typeof cordova !== 'undefined') {
        window.location.replace(`${process.env.BASE_URL}#${this.os}/${this.versionAPK}`)
      } else {
        window.location.replace(process.env.BASE_URL)
      }
    }
  },
  methods: {
    askForLogout () {
      if (Object.keys(this.account).length === 0) {
        this.$f7router.navigate('/', { reloadAll: true })
        return
      }
      this.$f7.dialog.confirm('¿Estás seguro de que deseas salir de tu cuenta?', 'Cerrar sesión', async () => {
        try {
          this.$f7.dialog.preloader('Eliminando datos locales...')
          await firebaseTools.signOut()
        } catch (err) {
          this.$f7.preloader.hide()
          console.error(err)
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../css/_brand";
.email-unverified{
  display: block;
  margin: 10px;
  padding: 5px;
  border-radius: 4px;
  text-align: center;
  word-wrap:break-word;
  color: $secondary-color;
  border: 1px dashed $secondary-color;
}
.card-no-roles{
  color: $dark-color;
  background: $bluegray;
  font-size: 12pt;
  padding: 20px;
  border-radius: 8px;
  margin: 10px auto;
  max-width: $width-pc;
}
.card-no-roles>span:not(:last-child){
  color: $secondary-color;
  text-transform: capitalize;
  font-weight: 600;
}
.card-no-roles>span:last-child{
  color: $white;
  background: $secondary-color;
  padding: 5px;
  border-radius: 4px;
  font-weight: 600;
}
.logo{
  display:block;
  width: 50vw;
  max-width: 170px;
  margin: 20px auto 0 auto;
  pointer-events: none;
}
.page-no-roles{
  background: $dark-color;
}
</style>
